import React, {useEffect, useState} from 'react'
import io from 'socket.io-client'

const SocketContext = React.createContext()

const getUsername = async () => {
    const username = localStorage.getItem('username')
    if (username) {
        console.log(`User existed ${username}`)
        return username
    }

    const res = await fetch('https://random-data-api.com/api/users/random_user')
    console.log(res)
    
    const { username: randomUsername } = await res.json()

    localStorage.setItem('username', randomUsername)
    //setUsername(username)
    return randomUsername
}



const SocketProvider = ({ children }) => {

    let socket;

    const [username, setUsername] = useState('sin_dato')

    const result =  localStorage.setItem('user', 'sin_dato')
    console.log("RESULT", result)

    const disconnect = () => {
        console.log('Disconnecting socket...');
        if(socket) socket.disconnect();
      }

    const connect = () => {
        const socket = io({ 
            path: "/socket.io",
            transports: ['websocket', 'polling'],
            auth: {
                username:  localStorage.getItem("user")//await getUsername(),
                //serverOffset: 0
              }
         });
        console.log(`Connecting socket...`);
    }    

    useEffect(()=>{

        //connect()

    }, [])

    /*useEffect(() => {
      

        if(username === 'sin_dato'){
            disconnect()
        } else {
            connect()
        }
              
        //getUsername()
        //setUsername(randomUsername)

        //if(username !== null){
             //io(ENDPOINT, { transports: ['websocket', 'polling'] })
        //}
        
    }, [])*/

    /*const socket = io({ 
        path: "/socket.io",
        transports: ['websocket', 'polling'],
        auth: {
            username:  username//localStorage.getItem("user")//await getUsername(),
            //serverOffset: 0
          }
     });*/

    
    //console.log(`Connecting socket desde SocketContext...`);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    )
}

export { SocketContext, SocketProvider }